import ButtonSlider from '@common_components/buttons/ButtonSlider';
import React from 'react';

interface SectorTabsProps {
  sectors: { id: string; name: string }[];
  onSectorClick: ( index: number ) => void;
  selectedIndex?: number;
}

const TabsSlider: React.FC<SectorTabsProps> = ( { sectors, onSectorClick, selectedIndex } ) => {
  return (
    <div className="flex w-full gap-x-4">
      {
        sectors.length > 0 ?
          <ButtonSlider
            buttonItems={sectors.map( sector => {return sector.name;} )}
            onButtonClick={index => {return onSectorClick( index );}}
            baseClassName="bg-white mb-4 shadow dark:bg-dark-bg-light w-full"
            textColor="text-gray-base-darkLight"
            sliderBg="bg-orange-100"
            activeTextColor="text-orange-600"
            selectedIndex={selectedIndex}
          />
          :
          <div className="w-full h-full py-2 shadow-md font-text border-l-4 border-r-4 border-blue-400 bg-blue-100 text-blue-800 flex-center">
            Ce site ne contient aucun secteurs
          </div>
      }
    </div>
  );
};

export default TabsSlider;
